export default __webpack_public_path__ + "images/barchart.05bc1af881ef5de659b31a87a6070f6d.svg";